import React, { useEffect } from 'react';
import Button from '@mui/material/Button';

import '../../style/common/alert.scss';
import { focusElemnt } from '../../utilityFunctions';

const Alert = (props) => {
    useEffect(() => {
        focusElemnt(`okayButton`)
    }, [])
    const { msg, alertType, close, className = '', buttonText, style = {} } = props

    return (
        <div className="alert" onClick={close}>
            <div
                className={`alert--content${alertType == "error" ? ' error' : ' success'} ${className}`}
                onClick={(e) => e.stopPropagation()}
                style={style}
            >
                {msg}
                {buttonText !== "" &&
                    <Button
                        id={`okayButton`}
                        variant="contained"
                        className={`alert-btn ${alertType == "error" ? ' error-btn' : ' success-btn'}`}
                        onClick={close}
                        autoFocus={true}
                    >
                        {buttonText}
                    </Button>
                }
            </div>
        </div>
    )
}

export default Alert;
